import { useCallback, useState } from "react"

import { PopoverDimensions, usePopoverPositioning } from "@/feature/tags/hooks"

export interface UsePopoverProps {
    buttonRef: React.RefObject<HTMLButtonElement | null>
    dialogRef: React.RefObject<HTMLDialogElement | null>
    defaultPopoverDimensions: PopoverDimensions
}

export const usePopover = ({ buttonRef, dialogRef, defaultPopoverDimensions }: UsePopoverProps) => {
  const [popoverDimensions, setPopoverDimensions] = useState(defaultPopoverDimensions)
  const { applyPosition } = usePopoverPositioning(popoverDimensions, { margin: 10 })

  const positionPopover = useCallback(() => {
    const buttonRect = buttonRef.current?.getBoundingClientRect()
    if (!dialogRef.current || !buttonRect) return

    // calculatePosition expects the trigger's bottom-left corner (it positions the popover just
    // below that point) — a DOMRect's own `x`/`y` are its top-left corner, so build the point
    // explicitly rather than passing the rect straight through.
    const popoverPosition = { x: buttonRect.left, y: buttonRect.bottom }

    const { offsetWidth, offsetHeight } = dialogRef.current

    if (offsetWidth !== popoverDimensions.width || offsetHeight !== popoverDimensions.height) {
      setPopoverDimensions({ width: offsetWidth, height: offsetHeight })
    }

    applyPosition(dialogRef.current, popoverPosition, popoverDimensions)
  }, [applyPosition, popoverDimensions])

  return {
    positionPopover
  }
}
